import { Leaf, ChefHat, Clock } from 'lucide-react';
import { useLanguage } from '../../context/LanguageContext';

export default function USPBar() {
  const { t } = useLanguage();

  const usps = [
    {
      icon: Leaf,
      title: t('usp.fresh'),
      description: t('usp.freshDesc'),
      color: 'text-primary-600 dark:text-primary-400'
    },
    {
      icon: ChefHat,
      title: t('usp.homemade'),
      description: t('usp.homemadeDesc'),
      color: 'text-accent-600 dark:text-accent-400'
    },
    {
      icon: Clock,
      title: t('usp.since'),
      description: t('usp.sinceDesc'),
      color: 'text-wine-600 dark:text-wine-400'
    }
  ];

  return (
    <section id="usp-section" className="py-12 md:py-16 bg-white dark:bg-gray-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-12">
          {usps.map((usp, index) => {
            const Icon = usp.icon;
            return (
              <div
                key={index}
                className="flex flex-col items-center text-center group"
              >
                <div className={`p-4 rounded-2xl bg-cream-100 dark:bg-gray-700 mb-4 group-hover:scale-110 transition-transform`}>
                  <Icon className={`w-8 h-8 ${usp.color}`} />
                </div>
                <h3 className="text-xl font-display font-semibold text-gray-900 dark:text-white mb-2">
                  {usp.title}
                </h3>
                <p className="text-gray-600 dark:text-gray-400">
                  {usp.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
